import React, { useEffect, useRef, useState } from 'react'
import PostCanvas from './PostCanvas'

// A post drawn to fit its box: a feed post fills a 4:5 box; a Story sits in
// the middle of it, as tall as the box, like a phone held up.
const Preview = ({ post, theme, format = post.format || 'post', className = '' }) => {
  const ref = useRef(null)
  const [w, setW] = useState(0)
  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const measure = () => setW(el.clientWidth)
    measure()
    if (typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver(measure)
    ro.observe(el)
    return () => ro.disconnect()
  }, [])
  const story = format === 'story'
  const width = story ? Math.round((w * 1.25 * 9) / 16) : w
  return (
    <span ref={ref} className={`sx-preview${story ? ' is-story' : ''} ${className}`}>
      {w > 0 && <PostCanvas post={post} theme={theme} format={format} width={width} thumb />}
    </span>
  )
}

export default Preview
